import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import DataGrid, { Scrolling, Lookup, Column, Editing, GroupPanel } from 'devextreme-react/data-grid';
import TabPanel, { Item as TabItem } from "devextreme-react/tab-panel";
import Form, { GroupItem, SimpleItem, Tab, TabbedItem, TabPanelOptions, Label, FormRef } from "devextreme-react/form";
import ICatalogue from "../../models/ICatalogue";
import Guid from "../../models/Guid";
import { FormListBase, FormListBaseTab, FormListBaseGrid, FormListBaseToolbar } from '../base';
import { TextBox, Button, FileUploader } from 'devextreme-react';
import IProduitImage from '../../models/IProduitImage';
import useCustomDataSource, { IFormBaseDataSourceOptions, Mode } from "../../hooks/useCustomDataSource";
import FormSysteme from '../../components/forms/form-systeme';
import { useContextLeftSidebarData } from '../../contexts/refreshDataSource';
import useLookUpBase from '../../components/selectbox/LookupBase';
import GestionProduitCategorie from '../gestion-produit-categorie/gestion-produit-categorie';
import GestionFolios from '../gestion-folios/gestion-folios';
import GestionProduitType from '../gestion-produit-type/gestion-produit-type';
import GestionProduitSousCategorie from '../gestion-produit-sous-categorie/gestion-produit-sous-categorie';
import GestionActivites from '../gestion-activites/gestion-activites';
import { useContextPopupPage } from '../../components/popups/PopupPage';
import './gestion-catalogue-produits.css';
import { Position, TabsIconPosition, TabsStyle } from 'devextreme/common';
import useApi from '../../hooks/useApi';
import IGestionCatalogueProduit from '../../models/IGestionCatalogueProduit';
import useEnum from '../../hooks/useEnum';

interface IGestionCatalogueProduitsProps {
  isModeSelection?: boolean,
}

export default function GestionCatalogueProduits({ isModeSelection }: IGestionCatalogueProduitsProps) {
  const { displayedElementInactif, setDisplayedElementInactif } = useContextLeftSidebarData();
  const reservationDataSourceOption: IFormBaseDataSourceOptions<IGestionCatalogueProduit> = useMemo(() => ({
    path: "catalogue",
    customReadByIdPath: "catalogue/{key}/gestion",
    customSauvegarderPath: "catalogue/save",
    // includeInactives: displayedElementInactif,
    primaryKey: "idProduit",
  }), []);
  // const catalogueProduitFormDataSource = useCustomDataSource<ICatalogue, ICatalogue>({ path: "catalogue", primaryKey: "idProduit", customSauvegarderPath: "catalogue/save", includeInactives: displayedElementInactif });
  const catalogueProduitFormDataSource = useCustomDataSource<ICatalogue, IGestionCatalogueProduit>(reservationDataSourceOption);

  const { selectedDataRow: selectedCatalogue, mode, setSelectedDataRow, onFieldDataChanged, setMainForm, setMode, isFieldModifier, setIsFieldModifier } = catalogueProduitFormDataSource;
  const { editorOptions: produitCategorieEditorOption, PopupGestion: PopupGestionProduitCategorie } = useLookUpBase({
    isModeModifier: mode !== Mode.Lecture, controllerName: "produitcategorie", titre: 'Gestionnaire des catégories de produits', showClear: mode !== Mode.Lecture,
    onClearRow: () => {
      setIsFieldModifier(true);
      formRef.current?.instance().updateData("idProduitCategorie", Guid.empty.toString());
    }
  });
  const { editorOptions: produitSousCategorieEditorOption, PopupGestion: PopupGestionProduitSousCategorie } = useLookUpBase({
    isModeModifier: mode !== Mode.Lecture, controllerName: "produitsouscategorie", titre: 'Gestionnaire des sous-catégories de produits', showClear: mode !== Mode.Lecture,
    onClearRow: () => {
      setIsFieldModifier(true);
      formRef.current?.instance().updateData("idProduitSousCategorie", Guid.empty.toString());
    }
  });
  const { editorOptions: folioEditorOption, PopupGestion: PopupGestionFolio } = useLookUpBase({
    isModeModifier: mode !== Mode.Lecture, controllerName: "folio", titre: 'Gestionnaire des folios', showClear: mode !== Mode.Lecture,
    onClearRow: () => {
      setIsFieldModifier(true);
      formRef.current?.instance().updateData("idFolio", Guid.empty.toString());
    }
  });
  const { editorOptions: produitTypeEditorOption, PopupGestion: PopupGestionProduitType } = useLookUpBase({
    isModeModifier: mode !== Mode.Lecture, controllerName: "produittype", titre: 'Gestionnaire des types de produits', showClear: mode !== Mode.Lecture,
    onClearRow: () => {
      setIsFieldModifier(true);
      formRef.current?.instance().updateData("idProduitType", Guid.empty.toString());
    }
  });
  // Exemple valeur nested
  const { editorOptions: activiteEditorOptions, PopupGestion: PopupGestionActivite } = useLookUpBase({
    isModeModifier: mode !== Mode.Lecture, controllerName: "activite", titre: 'Catalogue des activités', showClear: mode !== Mode.Lecture, width: '85%',
    onClearRow: () => {
      setIsFieldModifier(true);
      setSelectedDataRow(prev => ({ ...prev, speciauxIdActivite: Guid.empty }));
      formRef.current?.instance().updateData("speciauxIdActivite", Guid.empty.toString());
    }
  });
  const { editorOptions: produitRequisEditorOption, PopupGestion: PopupGestionProduitRequis } = useLookUpBase({
    isModeModifier: mode !== Mode.Lecture, controllerName: "catalogue", titre: 'Catalogue de produits', showClear: mode !== Mode.Lecture,
    onClearRow: () => {
      setIsFieldModifier(true);
      formRef.current?.instance().updateData("idProduitRequis", Guid.empty.toString());
    }
  });
  // const { editorOptions: facturesEditorOption } = useLookUpBase({ isModeModifier: mode !== Mode.Lecture, controllerName: "factureDetail", showClear: mode !== Mode.Lecture });
  const { editorOptions: catalogueEditorOption } = useLookUpBase({ isModeModifier: mode !== Mode.Lecture, controllerName: "catalogue", showClear: mode !== Mode.Lecture });
  const { getData } = useApi<object>();
  const { editorOptions: speciauxEligibiliteEditorOption } = useEnum(undefined, "gestionCatalogueProduitsSpeciauxEligibilite", '85%');
  const { editorOptions: speciauxTypeEditorOption } = useEnum(undefined, "gestionCatalogueProduitsSpeciauxType", '85%');
  const dataGridFilterValue = useMemo(() => ["isDeleted", "anyof", [null, false]], []);
  const { setSelectedValue } = useContextPopupPage();

  const { editorOptions: catalogueProduitEditorOptions, PopupGestion: PopupGestionCatalogueProduit } = useLookUpBase({ isModeModifier: mode !== Mode.Lecture, controllerName: "catalogue", titre: 'Catalogue des produits', showClear: mode !== Mode.Lecture });
  const { editorOptions: secteurEditorOptions, PopupGestion: PopupGestionSecteur } = useLookUpBase({ isModeModifier: mode !== Mode.Lecture, controllerName: "secteur", titre: 'Gestion des secteurs', showClear: mode !== Mode.Lecture });
  const { selectBox: typeOptionSelectBox } = useLookUpBase({ isModeModifier: mode !== Mode.Lecture, controllerName: 'catalogue', showClear: mode !== Mode.Lecture });

  const formRef = useRef<FormRef>(null);
  const residents = ["Tous", "Résident", "Non-Résident"];

  const tabsPositionsSelectBoxLabel = { 'aria-label': 'Tab position' };
  const tabsPositions: Position[] = [
    'left',
    'top',
    'right',
    'bottom',
  ];
  const stylingModesSelectBoxLabel = { 'aria-label': 'Styling mode' };
  const stylingModes: TabsStyle[] = [
    'secondary',
    'primary',
  ];
  const iconPositionsSelectBoxLabel = { 'aria-label': 'Icon positions' };
  const iconPositions: TabsIconPosition[] = [
    'top',
    'start',
    'end',
    'bottom',
  ];
  const [tabsPosition, setTabsPosition] = useState(tabsPositions[1]);
  const [stylingMode, setStylingMode] = useState(stylingModes[1]);
  const [iconPosition, setIconPosition] = useState(iconPositions[0]);
  const [selectedProduitImageId, setSelectedProduitImageId] = useState<Guid | undefined>();
  const imageFileUploaderRef = useRef<any>(null);


  const onTabsPositionChanged = useCallback((args: any) => {
    setTabsPosition(args.value);
  }, [setTabsPosition]);

  const onStylingModeChanged = useCallback((args: any) => {
    setStylingMode(args.value);
  }, [setStylingMode]);

  const onIconPositionChanged = useCallback((args: any) => {
    setIconPosition(args.value);
  }, [setIconPosition]);

  const activeProduitImages = useMemo(() => {
    return (selectedCatalogue?.produitImages || [])
      .filter((image: IProduitImage) => !image.isDeleted)
      .sort((a: IProduitImage, b: IProduitImage) => a.priorite - b.priorite);
  }, [selectedCatalogue?.produitImages]);

  const toProduitImageSrc = useCallback((image: IProduitImage['image']) => {
    if (!image) {
      return '';
    }
    if (typeof image === 'string') {
      return image.startsWith('data:') ? image : `data:image/jpeg;base64,${image}`;
    }
    return '';
  }, []);

  const updateProduitImages = useCallback((produitImages: IProduitImage[]) => {
    setSelectedDataRow(prev => ({
      ...prev,
      produitImages,
    }));
    setIsFieldModifier(true);
  }, [setSelectedDataRow, setIsFieldModifier]);

  const onProduitImageUploaded = useCallback((e: { value?: File[] }) => {
    const file = e.value?.[0];
    if (!file) {
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result as string;
      const base64 = result.includes(',') ? result.split(',')[1] : result;
      const nextPriorite = activeProduitImages.length > 0
        ? Math.max(...activeProduitImages.map(image => image.priorite)) + 1
        : 0;
      const newImage: IProduitImage = {
        idProduitImage: new Guid(),
        idProduit: selectedCatalogue?.idProduit || Guid.empty,
        image: base64,
        priorite: nextPriorite,
        isDeleted: false,
        dateCreation: new Date(),
        dateModification: new Date(),
        dateSuppression: null,
        idUsagerCreation: Guid.empty,
        idUsagerModification: Guid.empty,
        idUsagerSuppression: null,
      };

      updateProduitImages([...(selectedCatalogue?.produitImages || []), newImage]);
      setSelectedProduitImageId(newImage.idProduitImage);
      imageFileUploaderRef.current?.instance?.reset();
    };
    reader.readAsDataURL(file);
  }, [activeProduitImages, selectedCatalogue?.idProduit, selectedCatalogue?.produitImages, updateProduitImages]);

  const deleteSelectedProduitImage = useCallback(() => {
    if (!selectedProduitImageId) {
      return;
    }

    const produitImages = (selectedCatalogue?.produitImages || []).map((image: IProduitImage) => {
      if (!image.idProduitImage?.equals(selectedProduitImageId)) {
        return image;
      }
      return image.idProduitImage && !Guid.IsGuidTemporaire(image.idProduitImage)
        ? { ...image, isDeleted: true }
        : null;
    }).filter((image): image is IProduitImage => image !== null);

    updateProduitImages(produitImages);
    setSelectedProduitImageId(undefined);
  }, [selectedProduitImageId, selectedCatalogue?.produitImages, updateProduitImages]);

  const moveSelectedProduitImage = useCallback((direction: -1 | 1) => {
    if (!selectedProduitImageId) {
      return;
    }

    const currentIndex = activeProduitImages.findIndex(image =>
      image.idProduitImage?.equals(selectedProduitImageId)
    );
    const targetIndex = currentIndex + direction;
    if (currentIndex < 0 || targetIndex < 0 || targetIndex >= activeProduitImages.length) {
      return;
    }

    const reordered = [...activeProduitImages];
    const [movedImage] = reordered.splice(currentIndex, 1);
    reordered.splice(targetIndex, 0, movedImage);
    const reorderedWithPriorite = reordered.map((image, index) => ({ ...image, priorite: index }));
    const deletedImages = (selectedCatalogue?.produitImages || []).filter((image: IProduitImage) => image.isDeleted);

    updateProduitImages([...reorderedWithPriorite, ...deletedImages]);
  }, [activeProduitImages, selectedProduitImageId, selectedCatalogue?.produitImages, updateProduitImages]);

  // Cet useEffect permet de renitialiser la valueur boolean du hook useContextLeftSidebarData pour rafraichir les donnees
  useEffect(() => {
    setDisplayedElementInactif(false)
    setMainForm(formRef.current?.instance());
  }, [])

  useEffect(() => {
    // if (selectedCatalogue.idProduit)
    // _loadData(selectedCatalogue?.idProduit);
    if (mode !== Mode.Lecture) formRef.current?.instance().getEditor("description")?.focus();
  }, [mode])

  useEffect(() => {
    setSelectedProduitImageId(undefined);
  }, [selectedCatalogue?.idProduit])

  // const _loadDetailPrix = useCallback(async (IdProduit: Guid) => {
  //   console.log(IdProduit)
  //   const results = await getData({ customPath: `produitprix/${IdProduit}/detailprix` });
  //   const resultArray = Object.values(results);
  //   console.log(resultArray)
  //   // const _permissionGestionnaires: any[] = [];
  //   // const _permissionRapports: any[] = [];
  //   // const _permissionAutres: any[] = [];

  //   setSelectedDataRow((prev) => {
  //     return {
  //       ...prev,
  //       detailPrix: resultArray,
  //       // droitAccesDetail: [...prev?.droitAccesDetails || [], resultArray],
  //     } as ICatalogue
  //   });
  // }, [getData]);

  // const _loadData = useCallback(async (IdProduit: Guid) => {
  //   if (isModeSelection) return;
  //   console.log(IdProduit)
  //   await Promise.all([
  //     _loadDetailPrix(IdProduit),
  //   ]);
  // }, [_loadDetailPrix, isModeSelection]);

  const types = [{
    ID: 1,
    quantite: 10,
    prix: 99.99,
    auto: false,
  }, {
    ID: 2,
    quantite: 25,
    prix: 15.50,
    auto: true,
  }, {
    ID: 3,
    quantite: 0,
    prix: 50.00,
    auto: false,
  }];

  const { spinOptions, groupementEditorOptions, taxeTpsOptions, taxeTvqOptions, creditOptions, demanderMontantOptions, demanderDescriptionOptions, imprimerTaxesOptions, appliquerEscompteOptions, changerPrixProduitOptions, clientMemeAdresseOptions, gererInventaireOptions, speciauxQteOptions, actifOptions, afficherSurCarteMembreOptions, carteMembreOptions, campingAnnuelOptions, droitAccesAnnuelOptions, visiteurOptions, posOptions, pretEquipementOptions, disponibleEnLigneOptions, disponibleEnLigneVenteReservationOptions, billeterieOptions, descriptionWebFrancaiseOptions, descriptionWebAnglaiseOptions, prixEditorOptions, prixApresTaxeEditorOptions, dateEnVigueurEditorOptions } = useMemo(() => ({
    spinOptions: { min: 0, max: 999, showSpinButtons: true },
    groupementEditorOptions: { items: types },
    taxeTpsOptions: { text: "TPS" },
    taxeTvqOptions: { text: "TVQ" },
    creditOptions: { text: "Crédit" },
    demanderMontantOptions: { text: "Demander le montant (ex.: essence)" },
    demanderDescriptionOptions: { text: "Demander la description du produit" },
    imprimerTaxesOptions: { text: "Imprimer l'indicateur de taxes incluses" },
    appliquerEscompteOptions: { text: "Ne pas permettre d'appliquer d'escompte" },
    changerPrixProduitOptions: { text: "Permettre le changement de prix" },
    clientMemeAdresseOptions: { text: "Le client doit avoir la même adresse que le détenteur de produit requis" },
    gererInventaireOptions: { text: "Gérer l'inventaire" },
    speciauxQteOptions: {
      min: 0,
      max: 9999,
      showSpinButtons: true,
      width: 75,
      // inputAttr: { style: 'text-align: right' }
    },
    actifOptions: { text: "Actif" },
    afficherSurCarteMembreOptions: { text: "Afficher sur le tableau de bord des clients" },
    carteMembreOptions: { text: "Carte de membre" },
    campingAnnuelOptions: { text: "Camping annuel" },
    droitAccesAnnuelOptions: { text: "Accès annuel" },
    visiteurOptions: { text: "Visiteur" },
    posOptions: { text: "Point de vente" },
    pretEquipementOptions: { text: "Prêt d'équipement" },
    disponibleEnLigneOptions: { text: "Disponible en ligne" },
    disponibleEnLigneVenteReservationOptions: { text: "Disponible en ligne pour la vente avec réservation (site de réservation en ligne seulement)" },
    billeterieOptions: { text: "Billeterie" },
    descriptionWebFrancaiseOptions: { height: 300 },
    descriptionWebAnglaiseOptions: { height: 300 },
    prixEditorOptions: {
      format: "#,##0.00 $",
      step: 0.01,
      min: 0,
      width: 90
      // showSpinButtons: true
    },
    prixApresTaxeEditorOptions: {
      format: "#,##0.00 $",
      step: 0.01,
      min: 0,
      width: 90,
      onValueChanged: (e: any) => {
        if (e.value && e.value > 0) {
          const prixAvantTaxe = (e.value / 1.14975).toFixed(2);
          const formInstance = formRef.current?.instance();
          formInstance?.updateData("prixVente", parseFloat(prixAvantTaxe));
        }
      }
    },
    dateEnVigueurEditorOptions: {
      width: 90,
      displayFormat: 'dd-MM-yyyy'
    }
  }), []);

  const setDataRow = (e: string) => {
    // setSelectedDataRow((prev: ICatalogue) => (
    //   { ...prev, [e]: Guid.empty.toString() }
    // ));
    setIsFieldModifier(true);
  }
  const onSelectionchanged = (item: any, e: string) => {
    setIsFieldModifier(true);
    // setSelectedDataRow((prev: ICatalogue) => {
    //   return { ...prev, [e]: item.id }
    // })
  }

  const onCellClick = (e: any) => {
    // const _index = Data.findIndex(

    // );
    if (selectedCatalogue?.idProduit) {
      const resultArray = Object.values(e.row.data);
      // const newElement = {
      //   idClient: selectedClient.idClient,
      //   idVehicle: e.data.idVehicule,
      //   noPlaque: e.data.noPlaque
      // }
      // console.log(newElement)
      // setSelectedDataRow((prev) => {
      //   return {
      //     ...prev,
      //     vehicules: [...prev?.vehicules || [], newElement],
      //   } as IClient
      // });
      // setIsFieldModifier(true);
    }
  }

  const renderPrix = (data: any) => {
    const roundedAmount = data.data.prixVente.toFixed(2);
    return `${roundedAmount} $`;
  }

  const sortByPrix = (data: any) => {
    return data.prixVente;
  }

  // Calculate price after taxes reactively
  const prixApresTaxe = useMemo(() => {
    if (!selectedCatalogue?.prixVente) return 0;
    return selectedCatalogue.prixVente * 1.14975;
  }, [selectedCatalogue?.prixVente]);

  // Update the form data with calculated price after taxes
  useEffect(() => {
    if (selectedCatalogue && selectedCatalogue.prixVente) {
      setSelectedDataRow(prev => ({
        ...prev,
        prixApresTaxe: prixApresTaxe
      }));
    }
  }, [prixApresTaxe, setSelectedDataRow]);

  const renderPrixApresTaxe = () => {
    return <div
      style={{
        left: '65%',
        position: 'absolute',
        // textAlign: 'center',
        // fontSize: 12,
        // fontWeight: 'bold',
      }}
      className="dx-field-item-content dx-field-item-content-location-right" >
      <div className="dx-show-invalid-badge dx-numberbox dx-texteditor dx-editor-filled dx-state-readonly dx-widget" style={{ width: '90px' }}>
        <input type="hidden" value={prixApresTaxe} name="prixVente" readOnly />
        <div className="dx-texteditor-container">
          <div className="dx-texteditor-input-container">
            {prixApresTaxe &&
              <input className="dx-texteditor-input" type="text"
                value={prixApresTaxe} readOnly />
            }
            <div className="dx-placeholder dx-state-invisible">
            </div>
          </div>
          <div className="dx-texteditor-buttons-container">
            <div>
            </div>
            <div>
            </div>
          </div>
        </div>
      </div>
    </div>
    // return <div style={{
    //   left: '30%',
    //   position: 'absolute',
    //   width: '100%',
    //   textAlign: 'center',
    //   fontSize: 12,
    //   fontWeight: 'bold',
    // }}>{totalTax} $</div>
  }

  const totalPrice = useMemo(() => {
    return types
      .reduce((total, item) => total + item.prix, 0)
      .toLocaleString('en-US', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }, [types]);


  const tasks = [
    {
      status: 'Not Started',
      priority: 'high',
      text: 'Revenue Projections',
      date: '2023/09/16',
      assignedBy: 'John Heart',
    },
    {
      status: 'Not Started',
      priority: 'high',
      text: 'New Brochures',
      date: '2023/09/16',
      assignedBy: 'Samantha Bright',
    },
    {
      status: 'Not Started',
      priority: 'medium',
      text: 'Training',
      date: '2023/09/16',
      assignedBy: 'Arthur Miller',
    },
    {
      status: 'Not Started',
      priority: 'medium',
      text: 'NDA',
      date: '2023/09/16',
      assignedBy: 'Robert Reagan',
    },
    {
      status: 'Not Started',
      priority: 'low',
      text: 'Health Insurance',
      date: '2023/09/16',
      assignedBy: 'Greta Sims',
    },

    {
      status: 'Help Needed',
      priority: 'low',
      text: 'TV Recall',
      date: '2023/09/16',
      assignedBy: 'Brett Wade',
    },
    {
      status: 'Help Needed',
      priority: 'low',
      text: 'Recall and Refund Forms',
      date: '2023/09/16',
      assignedBy: 'Sandra Johnson',
    },
    {
      status: 'Help Needed',
      priority: 'high',
      text: 'Shippers',
      date: '2023/09/16',
      assignedBy: 'Ed Holmes',
    },
    {
      status: 'Help Needed',
      priority: 'medium',
      text: 'Hardware Upgrade',
      date: '2023/09/16',
      assignedBy: 'Barb Banks',
    },

    {
      status: 'In Progress',
      priority: 'medium',
      text: 'Online Sales',
      date: '2023/09/16',
      assignedBy: 'Cindy Stanwick',
    },
    {
      status: 'In Progress',
      priority: 'medium',
      text: 'New Website Design',
      date: '2023/09/16',
      assignedBy: 'Sammy Hill',
    },
    {
      status: 'In Progress',
      priority: 'low',
      text: 'Bandwidth Increase',
      date: '2023/09/16',
      assignedBy: 'Davey Jones',
    },
    {
      status: 'In Progress',
      priority: 'medium',
      text: 'Support',
      date: '2023/09/16',
      assignedBy: 'Victor Norris',
    },
    {
      status: 'In Progress',
      priority: 'low',
      text: 'Training Material',
      date: '2023/09/16',
      assignedBy: 'John Heart',
    },

    {
      status: 'Deferred',
      priority: 'medium',
      text: 'New Database',
      date: '2023/09/16',
      assignedBy: 'Samantha Bright',
    },
    {
      status: 'Deferred',
      priority: 'high',
      text: 'Automation Server',
      date: '2023/09/16',
      assignedBy: 'Arthur Miller',
    },
    {
      status: 'Deferred',
      priority: 'medium',
      text: 'Retail Sales',
      date: '2023/09/16',
      assignedBy: 'Robert Reagan',
    },
    {
      status: 'Deferred',
      priority: 'medium',
      text: 'Shipping Labels',
      date: '2023/09/16',
      assignedBy: 'Greta Sims',
    },

    {
      status: 'Rejected',
      priority: 'high',
      text: 'Schedule Meeting with Sales Team',
      date: '2023/09/16',
      assignedBy: 'Sandra Johnson',
    },
    {
      status: 'Rejected',
      priority: 'medium',
      text: 'Confirm Availability for Sales Meeting',
      date: '2023/09/16',
      assignedBy: 'Ed Holmes',
    },
    {
      status: 'Rejected',
      priority: 'medium',
      text: 'Reschedule Sales Team Meeting',
      date: '2023/09/16',
      assignedBy: 'Barb Banks',
    },
    {
      status: 'Rejected',
      priority: 'high',
      text: 'Update Database with New Leads',
      date: '2023/09/16',
      assignedBy: 'Kevin Carter',
    },
    {
      status: 'Rejected',
      priority: 'low',
      text: 'Send Territory Sales Breakdown',
      date: '2023/09/16',
      assignedBy: 'Cindy Stanwick',
    },

    {
      status: 'Completed',
      priority: 'medium',
      text: 'Territory Sales Breakdown Report',
      date: '2023/09/16',
      assignedBy: 'Sammy Hill',
    },
    {
      status: 'Completed',
      priority: 'low',
      text: 'Return Merchandise Report',
      date: '2023/09/16',
      assignedBy: 'Davey Jones',
    },
    {
      status: 'Completed',
      priority: 'high',
      text: 'Staff Productivity Report',
      date: '2023/09/16',
      assignedBy: 'Victor Norris',
    },
    {
      status: 'Completed',
      priority: 'medium',
      text: 'Review HR Budget Company Wide',
      date: '2023/09/16',
      assignedBy: 'Mary Stern',
    },
  ];
  const dataSource = [
    {
      icon: 'description',
      title: 'Not Started',
      tasks: tasks.filter((item) => item.status === 'Not Started'),
    },
    {
      icon: 'taskhelpneeded',
      title: 'Help Needed',
      tasks: tasks.filter((item) => item.status === 'Help Needed'),
    },
    {
      icon: 'taskinprogress',
      title: 'In Progress',
      tasks: tasks.filter((item) => item.status === 'In Progress'),
    },
    {
      icon: 'taskstop',
      title: 'Deferred',
      tasks: tasks.filter((item) => item.status === 'Deferred'),
    },
    {
      icon: 'taskrejected',
      title: 'Rejected',
      tasks: tasks.filter((item) => item.status === 'Rejected'),
    },
    {
      icon: 'taskcomplete',
      title: 'Completed',
      tasks: tasks.filter((item) => item.status === 'Completed'),
    },
  ];


  function TaskItem({ prop }: any) {
    return (
      <div className={`task-item task-item-priority-${prop.priority}`}>
        <span className="task-item-text">
          {/* {prop.text} */}
        </span>

        <span className="task-item-info">
          {/* {`${prop.date} by ${prop.assignedBy}`} */}
        </span>

        <i className="task-item-pseudo-button dx-icon dx-icon-overflow"></i>
      </div>
    );
  }

  function TabPanelItem({ data }: any) {
    const taskItems = data.tasks.map((task: any, index: any) => <TaskItem key={index} prop={task} />);

    return (
      <div className="tabpanel-item">
        {taskItems}
      </div>
    );
  }

  return (
    <FormListBase data={catalogueProduitFormDataSource}>
      <FormListBaseGrid dataSource={catalogueProduitFormDataSource.dataSource}
        onFocusedRowChanged={(e: any) => {
          if (mode === Mode.Modifier && !isModeSelection)
            setMode(Mode.Lecture);
          if (setSelectedValue && e.row?.data) {
            setSelectedValue(e.row.data);
          }
        }}
      >
        <Column key={"grid-col-description"} dataField={"description"} caption="Description" allowHiding={false} />
        <Column key={"grid-col-code-produit"} dataField={"codeProduit"} caption="Code" allowHiding={false} />
        <Column key={"grid-col-id-produit-categorie"} dataField={"idProduitCategorie"} caption="Catégorie" allowHiding={false}>
          <Lookup {...produitCategorieEditorOption} />
        </Column>
        <Column key={"grid-col-id-folio"} dataField={"idFolio"} caption="Folio" allowHiding={false}>
          <Lookup {...folioEditorOption} />
        </Column>
        <Column key={"grid-col-prix-vente"}
          caption="Prix de vente"
          allowHiding={false} cellRender={renderPrix}
          calculateSortValue={sortByPrix}
        />
      </FormListBaseGrid>
      <FormListBaseToolbar headerText={`${selectedCatalogue?.description || ''}`} sauvegarderOptions={{ disabled: !isFieldModifier }} annulerOptions={{ disabled: !isFieldModifier }} />
      {!isModeSelection || isModeSelection && mode !== Mode.Lecture
        ? <FormListBaseTab>
          <PopupGestionFolio
            onSelectionchanged={(data: any) => {
              setIsFieldModifier(true);
              formRef.current?.instance().updateData("idFolio", data.idFolio);
            }}
          >
            <GestionFolios isModeSelection={true} />
          </PopupGestionFolio>
          <PopupGestionProduitCategorie
            onSelectionchanged={(data: any) => {
              setIsFieldModifier(true);
              formRef.current?.instance().updateData("idProduitCategorie", data.idProduitCategorie);
            }}
          >
            <GestionProduitCategorie isModeSelection={true} />
          </PopupGestionProduitCategorie>
          <PopupGestionProduitSousCategorie
            onSelectionchanged={(data: any) => {
              setIsFieldModifier(true);
              formRef.current?.instance().updateData("idProduitSousCategorie", data.idProduitSousCategorie);
            }}
          >
            <GestionProduitSousCategorie isModeSelection={true} />
          </PopupGestionProduitSousCategorie>
          <PopupGestionProduitType
            onSelectionchanged={(data: any) => {
              setIsFieldModifier(true);
              formRef.current?.instance().updateData("idProduitType", data.idProduitType);
            }}
          >
            <GestionProduitType isModeSelection={true} />
          </PopupGestionProduitType>
          <PopupGestionProduitRequis
            onSelectionchanged={(data: any) => {
              setIsFieldModifier(true);
              formRef.current?.instance().updateData("idProduitRequis", data.idProduit);
            }}
          >
            <GestionCatalogueProduits isModeSelection={true} />
          </PopupGestionProduitRequis>
          <PopupGestionActivite
            onSelectionchanged={(data: any) => {
              const idActivite = data?.idActivite ?? data?.id;
              const speciauxIdActivite = idActivite instanceof Guid ? idActivite : new Guid(idActivite);
              setIsFieldModifier(true);
              setSelectedDataRow(prev => ({ ...prev, speciauxIdActivite }));
              const form = formRef.current?.instance();
              form?.updateData("speciauxIdActivite", speciauxIdActivite.toString());
              form?.getEditor("speciauxIdActivite")?.option("value", speciauxIdActivite.toString());
            }}
          >
            <GestionActivites isModeSelection={true} />
          </PopupGestionActivite>
          <TabItem title="Informations">
            {/* <div style={{ width: "100%", maxWidth: "100%" }}> */}
            <Form ref={formRef} readOnly={mode === Mode.Lecture}
              alignItemLabelsInAllGroups={true}
              formData={selectedCatalogue || {} as ICatalogue}
              className={"forms"} labelLocation={"left"}
              showColonAfterLabel={true}
              onFieldDataChanged={onFieldDataChanged}
            >
              <GroupItem>
                <GroupItem colCount={6}>
                  <GroupItem caption={"Produit"} colSpan={2}>
                    <SimpleItem key={"frm-description"} dataField={"description"} />
                    <SimpleItem key={"frm-code-produit"}
                      dataField={"codeProduit"}
                      editorOptions={{ width: 150 }}
                    >
                      <Label text={"Code de produit"} />
                    </SimpleItem>
                    <SimpleItem
                      key={"frm-id-folio"}
                      dataField={"idFolio"}
                      editorType={"dxSelectBox"}
                      editorOptions={folioEditorOption}>
                      <Label text={"Folio de vente"} />
                    </SimpleItem>
                    <SimpleItem key={"frm-id-produit-categorie"}
                      dataField={"idProduitCategorie"}
                      editorType={"dxSelectBox"}
                      editorOptions={produitCategorieEditorOption}
                    >
                      <Label text={"Catégorie"} />
                    </SimpleItem>
                    <SimpleItem
                      key={"frm-id-produit-sous-categorie"}
                      dataField={"idProduitSousCategorie"}
                      editorType={"dxSelectBox"}
                      editorOptions={produitSousCategorieEditorOption}
                    >
                      <Label text={"Sous-catégorie"} />
                    </SimpleItem>
                    <SimpleItem
                      key={"frm-id-produit-type"}
                      dataField={"idProduitType"}
                      editorType={"dxSelectBox"}
                      editorOptions={produitTypeEditorOption}
                    >
                      <Label text={"Type de produit"} />
                    </SimpleItem>
                    <SimpleItem key={"frm-upc"}
                      editorOptions={{ width: 150 }}
                      dataField={"upc"}>
                      <Label text={"Code UPC"} />
                    </SimpleItem>
                    <SimpleItem
                      key={"frm-id-produit-requis"}
                      dataField={"idProduitRequis"}
                      editorType={"dxSelectBox"}
                      editorOptions={produitRequisEditorOption}
                    >
                      <Label text={"Produit requis"} />
                    </SimpleItem>
                  </GroupItem>
                  <GroupItem colSpan={3}>
                    {/* <div className="tabpanel-demo">
                      <div className="widget-container">
                        <div className="widget-container">
                          <TabPanel
                            width="100%"
                            height={418}
                            // animationEnabled={true}
                            // swipeEnabled={true}
                            dataSource={dataSource}
                            tabsPosition={tabsPosition}
                            stylingMode={stylingMode}
                            iconPosition={iconPosition}
                            itemComponent={TabPanelItem}
                          />
                        </div>

                        <div className="options">
                          <div className="caption">Options</div>

                          <div className="option">
                            <div className="option-label">Tab position</div>

                            <SelectBox
                              inputAttr={tabsPositionsSelectBoxLabel}
                              items={tabsPositions}
                              value={tabsPosition}
                              onValueChanged={onTabsPositionChanged}
                            />
                          </div>

                          <div className="option">
                            <div className="option-label">Styling mode</div>

                            <SelectBox
                              inputAttr={stylingModesSelectBoxLabel}
                              items={stylingModes}
                              value={stylingMode}
                              onValueChanged={onStylingModeChanged}
                            />
                          </div>

                          <div className="option">
                            <div className="option-label">Icon position</div>

                            <SelectBox
                              inputAttr={iconPositionsSelectBoxLabel}
                              items={iconPositions}
                              value={iconPosition}
                              onValueChanged={onIconPositionChanged}
                            />
                          </div>
                        </div>
                      </div>
                    </div> */}

                    <TabbedItem>
                      <TabPanelOptions height={"100%"} deferRendering={false}
                      // animationEnabled={true}
                      // swipeEnabled={true}
                      />
                      <Tab title={"Tarification"}>
                        {/* <GroupItem colCount={4} cssClass="pricing-header">
                          <SimpleItem />
                          <SimpleItem>
                            <div className="center-label">
                              <label>Avant taxes</label>
                            </div>
                          </SimpleItem>
                          <SimpleItem>
                            <div className="center-label">
                              <label>Après taxes</label>
                            </div>
                          </SimpleItem>
                          <SimpleItem />
                        </GroupItem> */}
                        <GroupItem colCount={2} cssClass="pricing-row">
                          <GroupItem colSpan={1}>
                            <SimpleItem>
                              <div style={{ textAlign: 'left', fontWeight: 'bold', marginLeft: '85px' }}>
                                Avant taxes
                              </div>
                            </SimpleItem>
                            <SimpleItem key={"frm-prix-vente"}
                              dataField={"prixVente"}
                              editorType="dxNumberBox"
                              editorOptions={prixEditorOptions}>
                              <Label text='Prix de vente' />
                            </SimpleItem>
                          </GroupItem>
                          <GroupItem colSpan={1}>
                            <SimpleItem>
                              <div style={{ textAlign: 'left', fontWeight: 'bold', marginLeft: '5px' }}>
                                Après taxes
                              </div>
                            </SimpleItem>
                            <SimpleItem key={"frm-prix-vente-apres-taxe"}
                              dataField={"prixApresTaxe"}
                              editorType="dxNumberBox"
                              editorOptions={prixApresTaxeEditorOptions}
                            >
                              <Label visible={false} />
                            </SimpleItem>
                          </GroupItem>
                        </GroupItem>
                        <GroupItem colCount={2}>
                          <SimpleItem key={"frm-prix-coutant"} dataField={"prixCoutant"}
                            editorType="dxNumberBox"
                            editorOptions={prixEditorOptions}>
                            <Label text='Prix coutant' />
                          </SimpleItem>
                        </GroupItem>
                        <SimpleItem key={"frm-taxe-tps"} dataField={"taxeTps"} editorType={"dxCheckBox"}
                          editorOptions={taxeTpsOptions}>
                          <Label visible={false} />
                        </SimpleItem>
                        <SimpleItem key={"frm-taxe-tvq"} dataField={"taxeTps"} editorType={"dxCheckBox"}
                          editorOptions={
                            taxeTvqOptions
                          }
                        >
                          <Label visible={false} />
                        </SimpleItem>
                        <SimpleItem key={"frm-credit"} dataField={"credit"} editorType={"dxCheckBox"}
                          editorOptions={
                            creditOptions
                          }
                        >
                          <Label visible={false} />
                        </SimpleItem>
                        <SimpleItem key={"frm-demander-montant"} dataField={"demanderMontant"} editorType={"dxCheckBox"}
                          editorOptions={
                            demanderMontantOptions
                          }
                        >
                          <Label visible={false} />
                        </SimpleItem>
                        <SimpleItem key={"frm-demander-description"} dataField={"demanderDescription"} editorType={"dxCheckBox"}
                          editorOptions={
                            demanderDescriptionOptions
                          }
                        >
                          <Label visible={false} />
                        </SimpleItem>
                        <SimpleItem key={"frm-imprimer-taxes-incluses"} dataField={"imprimerTaxesIncluses"} editorType={"dxCheckBox"}
                          editorOptions={
                            imprimerTaxesOptions
                          }
                        >
                          <Label visible={false} />
                        </SimpleItem>
                        <SimpleItem key={"frm-appliquer-escompte-client"} dataField={"appliquerEscompteClient"} editorType={"dxCheckBox"}
                          editorOptions={
                            appliquerEscompteOptions
                          }
                        >
                          <Label visible={false} />
                        </SimpleItem>
                        <SimpleItem key={"frm-changer-prix-produit"} dataField={"changerPrixProduit"} editorType={"dxCheckBox"}
                          editorOptions={
                            changerPrixProduitOptions
                          }
                        >
                          <Label visible={false} />
                        </SimpleItem>
                        <SimpleItem key={"frm-client-meme-adresse"} dataField={"clientMemeAdresse"} editorType={"dxCheckBox"}
                          editorOptions={
                            clientMemeAdresseOptions
                          }
                        >
                          <Label visible={false} />
                        </SimpleItem>
                      </Tab>
                      <Tab title={"Inventaire"}>
                        <SimpleItem
                          key={"frm-gerer-inventaire"}
                          dataField={"gererInventaire"} editorType={"dxCheckBox"}
                          editorOptions={gererInventaireOptions}
                        >
                          <Label visible={false} />
                        </SimpleItem>
                        {selectedCatalogue?.gererInventaire &&
                          <GroupItem>
                            <DataGrid
                              dataSource={selectedCatalogue.inventaire}
                              showBorders={true} allowColumnResizing={true}>
                              <Column dataField='nomPoste' dataType='string' caption={"Emplacement"} />
                              <Column dataField='quantiteFacturation' dataType='number' caption={"Quantité en main"} />
                            </DataGrid>
                          </GroupItem>
                        }
                      </Tab>
                      <Tab title={"Groupement"}>
                        <GroupItem>
                          <DataGrid
                            // dataSource={types}
                            showBorders={true}
                            allowColumnResizing={true}

                            dataSource={selectedCatalogue.groupement}
                            allowColumnReordering={false}
                            filterValue={dataGridFilterValue}
                            noDataText={""}
                            onInitNewRow={(e: any) => {
                              e.data.idProduit = selectedCatalogue.idProduit;
                              e.data.isDeleted = false;
                            }}
                            onEditorPreparing={(e: any) => {
                              const originalOnValueChanged = e.editorOptions.onValueChanged;
                              e.editorOptions.onValueChanged = (args: any) => {
                                if (originalOnValueChanged) {
                                  originalOnValueChanged(args);
                                }

                                const currentData = e.component.option("dataSource");
                                const rowIndex = e.rowIndex;
                                const rowData = currentData[rowIndex];

                                const updatedData = currentData.filter((_: any, index: any) => index !== rowIndex);
                                setSelectedDataRow(prev => ({
                                  ...prev,
                                  joursReservations: updatedData
                                }));
                                setIsFieldModifier(true);
                              }
                            }}
                            onRowRemoving={async (e) => {
                              e.cancel = true;
                              // if (e?.data?.idPermisType) {
                              const index = selectedCatalogue.groupement.findIndex(item =>
                                item.idProduitGroupe?.equals(e.data.idProduitGroupe)
                              );
                              if (index !== -1) {
                                const updatedData = [...selectedCatalogue.groupement];
                                updatedData[index] = { ...updatedData[index], isDeleted: true };
                                setSelectedDataRow(prev => ({
                                  ...prev,
                                  groupement: updatedData
                                }));
                              }
                              // }
                            }}
                          >
                            <Editing
                              mode="cell"
                              allowUpdating={mode !== Mode.Lecture}
                              allowDeleting={mode !== Mode.Lecture}
                              allowAdding={mode !== Mode.Lecture}
                              newRowPosition={"first"}
                              startEditAction={"click"}
                            />
                            <Column dataType='number' dataField='quantite' width={50} caption={"Quantité"} />
                            <Column dataField="idProduit" caption="Produit"
                              editorOptions={{
                                ...catalogueEditorOption,
                                dropDownOptions: {
                                  width: 400,
                                  height: 300
                                },
                                // itemTemplate: (data: any) => {
                                //   if (!data) return '';
                                //   console.log(data);
                                //   return (
                                //     <div style={{ padding: '4px 0', lineHeight: '1.3' }}>
                                //       <div style={{ fontWeight: 'bold', fontSize: '13px' }}>
                                //         {data.description}
                                //       </div>
                                //       <div style={{ color: '#666', fontSize: '11px', marginTop: '2px' }}>
                                //         <span>Code: {data.codeProduit || 'N/A'}</span>
                                //         {data.prix && (
                                //           <span style={{ marginLeft: '15px' }}>
                                //             Prix: {parseFloat(data.prix).toFixed(2)} $
                                //           </span>
                                //         )}
                                //       </div>
                                //     </div>
                                //   );
                                // }
                              }}>
                              <Lookup {...catalogueEditorOption} />
                            </Column>
                            {/* {typeOptionSelectBox && <Column dataField="idProduit" caption="Produit" cellRender={typeOptionSelectBox} />} */}
                            <Column dataType='number' dataField='prix' width={125} caption={"Prix unitaire"} />
                            <Column dataType='boolean' dataField='associer' width={100} caption={"Inclure auto."} />
                            <Column dataField="isDeleted" dataType="boolean" visible={false} />
                          </DataGrid>
                        </GroupItem>
                        <SimpleItem key={"prix-total"}>
                          <div style={{ display: "flex", justifyContent: "center" }}>
                            <TextBox width={"25%"} readOnly={true} value={totalPrice} />
                          </div>
                        </SimpleItem>
                      </Tab>
                      <Tab title={"Spéciaux"}>
                        <SimpleItem key={"frm-speciaux-eligibilite"}
                          dataField={"speciauxEligibilite"} editorType={"dxSelectBox"}
                          editorOptions={
                            speciauxEligibiliteEditorOption
                          }>
                          <Label text={"Éligibilité"} />
                        </SimpleItem>
                        <SimpleItem key={"frm-speciaux-type"} dataField={"speciauxType"} editorType={"dxSelectBox"}
                          editorOptions={
                            speciauxTypeEditorOption
                          }>
                          <Label text={"Type"} />
                        </SimpleItem>
                        <SimpleItem
                          key={"frm-speciaux-id-activite"}
                          dataField={"speciauxIdActivite"}
                          editorType={"dxSelectBox"}
                          editorOptions={activiteEditorOptions}
                        >
                          <Label text={"Activité"} />
                        </SimpleItem>
                        <SimpleItem key={"frm-speciaux-qte"} dataField={"speciauxQte"} editorType={"dxNumberBox"}
                          editorOptions={
                            speciauxQteOptions
                          }>
                          <Label text={"Quantité"} />
                        </SimpleItem>
                        <SimpleItem key={"frm-speciaux-date-vigueur"} dataField={"speciauxDateVigueur"} editorType={"dxDateBox"} editorOptions={dateEnVigueurEditorOptions}>
                          <Label text={"Date d'entrée en vigeur"} />
                        </SimpleItem>
                      </Tab>
                    </TabbedItem>
                  </GroupItem>
                  <GroupItem caption={"Statut"} colSpan={1}>
                    <SimpleItem key={"frm-actif"} dataField={"actif"} editorType={"dxCheckBox"}
                      editorOptions={
                        actifOptions
                      }
                    >
                      <Label visible={false} />
                    </SimpleItem>
                    <SimpleItem key={"frm-afficher-sur-carte-membre"} dataField={"afficherSurCarteMembre"} editorType={"dxCheckBox"}
                      editorOptions={
                        afficherSurCarteMembreOptions
                      }
                    >
                      <Label visible={false} />
                    </SimpleItem>
                    <SimpleItem key={"frm-carte-membre"} dataField={"carteMembre"} editorType={"dxCheckBox"}
                      editorOptions={
                        carteMembreOptions
                      }
                    >
                      <Label visible={false} />
                    </SimpleItem>
                    <SimpleItem key={"frm-camping-annuel"} dataField={"campingAnnuel"} editorType={"dxCheckBox"}
                      editorOptions={
                        campingAnnuelOptions
                      }
                    >
                      <Label visible={false} />
                    </SimpleItem>
                    <SimpleItem key={"frm-droit-acces-annuel"} dataField={"droitAccesAnnuel"} editorType={"dxCheckBox"}
                      editorOptions={
                        droitAccesAnnuelOptions
                      }
                    >
                      <Label visible={false} />
                    </SimpleItem>
                    <SimpleItem key={"frm-visiteur"} dataField={"visiteur"} editorType={"dxCheckBox"}
                      editorOptions={
                        visiteurOptions
                      }
                    >
                      <Label visible={false} />
                    </SimpleItem>
                    <SimpleItem key={"frm-pos"} dataField={"pos"} editorType={"dxCheckBox"}
                      editorOptions={
                        posOptions
                      }
                    >
                      <Label visible={false} />
                    </SimpleItem>
                    <SimpleItem key={"frm-pret-equipement"} dataField={"pretEquipement"} editorType={"dxCheckBox"}
                      editorOptions={
                        pretEquipementOptions
                      }
                    >
                      <Label visible={false} />
                    </SimpleItem>
                  </GroupItem>
                </GroupItem>

                <GroupItem caption={"Détail des prix"} >
                  <div style={{
                    width: '100%',
                    maxWidth: '100vw',
                    overflow: 'hidden',
                    boxSizing: 'border-box',
                    position: 'relative'
                  }}>
                    <DataGrid
                      className='scrollable-x'
                      // dataSource={selectedCatalogue.detailPrix}
                      showBorders={true}
                      columnAutoWidth={false}
                      width={'100%'}
                      height={"250px"}
                      // onRowInserted={onCellClick}
                      // onInitNewRow={() => ({} as IProduitPrix)}
                      filterValue={dataGridFilterValue}
                      allowColumnResizing={true}
                      dataSource={selectedCatalogue.detailPrix}
                      allowColumnReordering={false}
                      noDataText={""}
                      onInitNewRow={(e: any) => {
                        e.data.idProduit = selectedCatalogue.idProduit;
                        e.data.isDeleted = false;
                      }}
                      onEditorPreparing={(e: any) => {
                        const originalOnValueChanged = e.editorOptions.onValueChanged;
                        e.editorOptions.onValueChanged = (args: any) => {
                          if (originalOnValueChanged) {
                            originalOnValueChanged(args);
                          }

                          const currentData = e.component.option("dataSource");
                          const rowIndex = e.rowIndex;
                          const rowData = currentData[rowIndex];

                          const updatedData = currentData.filter((_: any, index: any) => index !== rowIndex);
                          setSelectedDataRow(prev => ({
                            ...prev,
                            detailPrix: updatedData
                          }));
                          setIsFieldModifier(true);
                        }
                      }}
                      onRowRemoving={async (e) => {
                        e.cancel = true;
                        // if (e?.data?.idPermisType) {
                        const index = selectedCatalogue.detailPrix.findIndex(item =>
                          item.idProduitPrix?.equals(e.data.idProduitPrix)
                        );
                        if (index !== -1) {
                          const updatedData = [...selectedCatalogue.detailPrix];
                          updatedData[index] = { ...updatedData[index], isDeleted: true };
                          setSelectedDataRow(prev => ({
                            ...prev,
                            detailPrix: updatedData
                          }));
                        }
                        // }
                      }}
                    >
                      <Scrolling
                        mode="standard"
                        useNative={false}
                        scrollByContent={true}
                        scrollByThumb={true}
                        showScrollbar="always"
                      />
                      <Editing
                        mode="cell"
                        allowUpdating={mode !== Mode.Lecture}
                        allowDeleting={mode !== Mode.Lecture}
                        allowAdding={mode !== Mode.Lecture}
                        newRowPosition={"first"}
                        startEditAction={"click"}
                      />
                      <GroupPanel visible={false} />
                      <Column dataField="description" dataType='string' width={95} caption={"Description"} />
                      <Column dataField="prix" dataType='number' width={80} caption={"Prix"} />
                      <Column dataField="nombreJours" dataType='number' width={100} caption={"Nombre Jours"} />
                      <Column dataField="nombreJoursConsecutif" dataType='boolean' width={80} caption={"Consécutif"} />
                      <Column dataField="heureDebut" dataType='datetime' width={80} caption={"Heure début"} />
                      <Column dataField="heureFin" dataType='datetime' width={80} caption={"Heure fin"} />
                      <Column dataField="etudiant" dataType='boolean' width={80} caption={"Étudiant"} />
                      <Column dataField="forfaitFamilial" dataType='boolean' width={80} caption={"Famille"} />
                      <Column dataField="conjoint" dataType='boolean' width={80} caption={"Conjoint"} />
                      <Column dataField="statutMembre" dataType='string' width={80} caption={"Membre"} editorOptions={speciauxTypeEditorOption} />
                      <Column dataField="statutResident" dataType='string' width={80} caption={"Résident"} editorOptions={residents} />
                      <Column dataField="ageDebut" dataType='number' width={80} caption={"Âge début"} editorOptions={spinOptions} />
                      <Column dataField="ageFin" dataType='number' width={80} caption={"Âge fin"} editorOptions={spinOptions} />
                      <Column dataField="idSecteur" dataType='string' width={80} caption={"Secteur"} editorOptions={secteurEditorOptions}>
                        <Lookup {...secteurEditorOptions} />
                      </Column>
                      <Column dataField="dateDebut" dataType='date' width={80} caption={"Date début"} />
                      <Column dataField="dateFin" dataType='date' width={80} caption={"Date fin"} />
                      <Column dataField='idFolio' dataType='string' width={80} caption={"Folio"} editorOptions={secteurEditorOptions}>
                        <Lookup {...secteurEditorOptions} />
                      </Column>
                      <Column dataType='boolean' width={80} caption={"Ventilation"} />
                      <Column dataField="isDeleted" dataType="boolean" visible={false} />
                    </DataGrid>
                  </div>
                </GroupItem>
              </GroupItem>
            </Form>
            {/* </div> */}
          </TabItem>
          <TabItem title="Liste des factures">
            <Form ref={formRef} readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedCatalogue || {} as ICatalogue} className={"forms"} labelLocation={"left"} showColonAfterLabel={true} onFieldDataChanged={onFieldDataChanged}>
              <GroupItem colCount={2}>
                <SimpleItem key={"recherche-facture"}
                  editorType={"dxTextBox"}
                />
                <SimpleItem key={"b1"}>
                  <span style={{ marginRight: "1em" }}>
                    <Button text={"Trouver"} />
                  </span>
                  <span>
                    <Button text={"Effacer"} />
                  </span>
                </SimpleItem>
              </GroupItem>
              <GroupItem>
                <DataGrid
                  // dataSource={facturesEditorOption.dataSource}
                  showBorders={true}
                  allowColumnResizing={true}>
                  <Column caption={"No. facture"} />
                  <Column caption={"Date de vente"} />
                  <Column caption={"Client"} />
                  <Column caption={"Quantité"} />
                  <Column caption={"Prix"} />
                  <Column caption={"Montant"} />
                </DataGrid>
              </GroupItem>
            </Form>
          </TabItem>
          <TabItem title="Internet">
            <Form ref={formRef} readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedCatalogue || {} as ICatalogue} className={"forms"} labelLocation={"left"} showColonAfterLabel={true} onFieldDataChanged={onFieldDataChanged}>
              <SimpleItem key={"frm-disponible-en-ligne"} dataField={"disponibleEnLigne"} editorType={"dxCheckBox"}
                editorOptions={
                  disponibleEnLigneOptions
                }
              >
                <Label visible={false} />
              </SimpleItem>
              <SimpleItem key={"frm-disponible-en-ligne-vente-reservation"} dataField={"disponibleEnLigneVenteReservation"} editorType={"dxCheckBox"}
                editorOptions={
                  disponibleEnLigneVenteReservationOptions
                }
              >
                <Label visible={false} />
              </SimpleItem>
              <SimpleItem key={"frm-billeterie"} dataField={"billeterie"} editorType={"dxCheckBox"}
                editorOptions={
                  billeterieOptions
                }
              >
                <Label visible={false} />
              </SimpleItem>
              <GroupItem caption={"Affichage"}>
                <GroupItem colCount={2}>
                  <SimpleItem key={"frm-description-web-francaise"} dataField={"descriptionWebFrancaise"} editorType={"dxTextArea"}
                    editorOptions={
                      descriptionWebFrancaiseOptions
                    }>
                    <Label text={"Description française"} location={"top"} />
                  </SimpleItem>
                  <SimpleItem key={"frm-description-web-anglaise"} dataField={"descriptionWebAnglaise"} editorType={"dxTextArea"}
                    editorOptions={
                      descriptionWebAnglaiseOptions
                    }>
                    <Label text={"Description anglaise"} location={"top"} />
                  </SimpleItem>
                </GroupItem>
                <GroupItem caption={"Images"}>
                  <SimpleItem key={"b2"}>
                    <span style={{ marginRight: "1em" }}>
                      <FileUploader
                        ref={imageFileUploaderRef}
                        disabled={mode === Mode.Lecture}
                        accept="image/*"
                        uploadMode="useForm"
                        showFileList={false}
                        selectButtonText="Ajouter une image"
                        labelText=""
                        onValueChanged={onProduitImageUploaded}
                      />
                    </span>
                    <span style={{ marginRight: "1em" }}>
                      <Button
                        text={"Supprimer une image"}
                        width={""}
                        disabled={mode === Mode.Lecture || !selectedProduitImageId}
                        onClick={deleteSelectedProduitImage}
                      />
                    </span>
                    <span style={{ marginRight: "1em" }}>
                      <Button
                        text={"↑"}
                        width={"5%"}
                        disabled={mode === Mode.Lecture || !selectedProduitImageId}
                        onClick={() => moveSelectedProduitImage(-1)}
                      />
                    </span>
                    <span>
                      <Button
                        text={"↓"}
                        width={"5%"}
                        disabled={mode === Mode.Lecture || !selectedProduitImageId}
                        onClick={() => moveSelectedProduitImage(1)}
                      />
                    </span>
                  </SimpleItem>
                  <SimpleItem key={"catalogue-produit-images"}>
                    <div className="gestion-catalogue-produit-photo-grid">
                      {activeProduitImages.map((image: IProduitImage) => (
                        <div
                          key={image.idProduitImage?.toString()}
                          className={`gestion-catalogue-produit-photo-item ${selectedProduitImageId?.equals(image.idProduitImage) ? 'gestion-catalogue-produit-photo-item-selected' : ''}`}
                          onClick={() => {
                            if (!image.idProduitImage) {
                              return;
                            }
                            setSelectedProduitImageId(image.idProduitImage instanceof Guid ? image.idProduitImage : new Guid(image.idProduitImage));
                          }}
                        >
                          <img
                            src={toProduitImageSrc(image.image)}
                            alt="Image produit"
                            style={{
                              width: 150,
                              height: 110,
                              objectFit: 'cover'
                            }}
                          />
                        </div>
                      ))}
                    </div>
                  </SimpleItem>
                </GroupItem>
              </GroupItem>
            </Form>
          </TabItem>
          <TabItem title="Système"><FormSysteme formData={selectedCatalogue || {} as ICatalogue} /></TabItem>
        </FormListBaseTab> : null
      }
    </FormListBase >
  );
}

function setDataRow(arg0: string) {
  throw new Error('Function not implemented.');
}

